import { mapGetters } from "vuex";
import Feature from "ol/Feature.js";
import { Point, LineString } from "ol/geom.js";
var geoconfig = require("./../geo_config");

export default {
  computed: {
    ...mapGetters({
      totalLength: "getTotalLenght"
    })
  },
  methods: {
    formatLength(length) {
      var output;
      if (length > 100) {
        output = Math.round((length / 1000) * 100) / 100 + " " + "km";
      } else {
        output = Math.round(length * 100) / 100 + " " + "m";
      }
      return output;
    },
    removeElementFeature(source, element) {
      var feature = source.getFeatureById(element.id);
      source.removeFeature(feature);
    },
    nodeToFeature(node) {
      // console.log('nodeToFeature', node)
      if (this.tempLength < 10000) {
        this.$store.dispatch("setLength", parseFloat(this.lineLenght));

        var feature = new Feature({
          geometry: new Point(node.coordinate),
          node: node
        });

        let features = geoconfig.nodeSource.getFeatures();
        feature.setId(features.length + 1);
        console.log("nodeToFeature", feature);
        geoconfig.nodeSource.addFeature(feature);
      } else {
        this.snackbarMessage =
          "Must be a draw length with a maximum length of 10km.";
        this.snackbar = true;
      }
    },
    edgeToFeature(edge) {
      // console.log('edgeToFeature', this.tempLength)
      if (this.tempLength < 10000) {
        var feature = new Feature({
          geometry: new LineString(edge.coordinates),
          edge: edge
        });
        feature.setId(this.arrayList.length + 1);
        // feature.setId(edge.id);
        // console.log(feature.id)
        // console.log('this.arrayList.length + 1', this.arrayList.length + 1)
        geoconfig.drawSource.addFeature(feature);
      } else {
        this.snackbarMessage =
          "Must be a draw length with a maximum length of 10km.";
        this.snackbar = true;
      }
    },
    createNode(topo, coord) {
      var node;
      var existingEdge = topo.getEdgeByPoint(coord, 5)[0];
      if (existingEdge) {
        node = topo.modEdgeSplit(existingEdge, coord);
      } else {
        node = topo.addIsoNode(coord);
      }
      return node;
    },
    onDrawend(e) {
      var edgeGeom = e.feature.getGeometry().getCoordinates();

      var startCoord = edgeGeom[0];
      var endCoord = edgeGeom[edgeGeom.length - 1];
      var start, end;

      try {
        if (this.tempLength < 10000) {
          start = this.topo.getNodeByPoint(startCoord);
          end = this.topo.getNodeByPoint(endCoord);
          var edgesAtStart = this.topo.getEdgeByPoint(startCoord, 5);
          var edgesAtEnd = this.topo.getEdgeByPoint(endCoord, 5);
          var crossing = this.topo.getEdgesByLine(edgeGeom);

          if (
            crossing.length === 1 &&
            !start &&
            !end &&
            edgesAtStart.length === 0 &&
            edgesAtEnd.length === 0
          ) {
            this.topo.remEdgeNewFace(crossing[0]);
            start = crossing[0].start;
            if (start.face) {
              this.topo.removeIsoNode(start);
            }
            end = crossing[0].end;
            if (end.face) {
              this.topo.removeIsoNode(end);
            }
            return;
          }

          if (!start) {
            start = this.createNode(this.topo, startCoord);
            edgeGeom[0] = start.coordinate;
          }
          if (!end) {
            end = this.createNode(this.topo, endCoord);
            edgeGeom[edgeGeom.length - 1] = end.coordinate;
          }
          this.topo.addEdgeNewFaces(start, end, edgeGeom);

          this.arrayList = this.arrayList.concat(edgeGeom);
        }
      } catch (e) {
        console.log(e.toString());
        geoconfig.drawSource.clear();
        geoconfig.nodeSource.clear();
        this.$store.dispatch("setLength", 0);
        this.$store.dispatch("setPoints", []);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/draw.js